import { useState } from "react"
import { X, User, Phone } from "lucide-react"
import { motion, AnimatePresence } from "framer-motion"
import { createSupplier } from "../../api/suppliers/post"

type Props = {
    currentStore: any
    isOpen: boolean
    onClose: () => void
    onAdded: (supplier: any) => void
}

export default function AddSupplierModal({
    currentStore,
    isOpen,
    onClose,
    onAdded,
}: Props) {
    const [name, setName] = useState("")
    const [phone, setPhone] = useState("")
    const [error, setError] = useState("")
    const [loading, setLoading] = useState(false)

    const submit = async () => {
        setError("")

        if (!name.trim()) {
            setError("Nom du fournisseur requis")
            return
        }

        try {
            setLoading(true)
            const res = await createSupplier({ name, phone, storeId: currentStore?._id })
            console.log({res})
            onAdded(res)

            // reset
            setName("")
            setPhone("")
            onClose()
        } catch (e: any) {
            console.log({e})
            setError(e?.message || e?.response?.data?.message || "Erreur lors de la création")
        } finally {
            setLoading(false)
        }
    }

    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                >
                    <motion.div
                        className="bg-white rounded-2xl shadow-xl w-full max-w-md p-6 space-y-6"
                        initial={{ scale: 0.9, y: 40 }}
                        animate={{ scale: 1, y: 0 }}
                        exit={{ scale: 0.9, y: 40 }}
                        transition={{ duration: 0.25 }}
                    >
                        {/* Header */}
                        <div className="flex items-center justify-between">
                            <h2 className="text-lg font-semibold text-gray-800">
                                Nouveau fournisseur
                            </h2>
                            <button
                                onClick={onClose}
                                className="p-1 rounded-lg hover:bg-gray-100"
                            >
                                <X />
                            </button>
                        </div>

                        {/* Error */}
                        {error && (
                            <div className="bg-red-50 text-red-600 text-sm p-2 rounded-lg">
                                {error}
                            </div>
                        )}

                        {/* Form */}
                        <div className="space-y-4">

                            {/* Nom */}
                            <Input
                                icon={<User size={18} />}
                                placeholder="Nom du fournisseur *"
                                value={name}
                                onChange={(e: any) => setName(e.target.value)}
                            />

                            {/* Téléphone */}
                            <Input
                                icon={<Phone size={18} />}
                                placeholder="Téléphone (optionnel)"
                                value={phone}
                                onChange={(e: any) => setPhone(e.target.value)}
                            />

                        </div>

                        {/* Actions */}
                        <div className="flex justify-end gap-3 pt-2">
                            <button
                                onClick={onClose}
                                className="px-4 py-2 rounded-xl border hover:bg-gray-50"
                            >
                                Annuler
                            </button>
                            <button
                                onClick={submit}
                                disabled={loading}
                                className="
                  px-4 py-2 rounded-xl
                  bg-blue-600 hover:bg-blue-700
                  text-white font-medium
                  transition disabled:opacity-60
                "
                            >
                                {loading ? "Enregistrement..." : "Enregistrer"}
                            </button>
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </AnimatePresence>
    )
}

/* ---------- INPUT ---------- */

function Input({ icon, ...props }: any) {
    return (
        <div className="relative">
            <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                {icon}
            </div>
            <input
                {...props}
                className="
          w-full pl-10 pr-4 py-2.5
          rounded-xl border border-gray-200
          focus:ring-2 focus:ring-blue-500
          outline-none transition
        "
            />
        </div>
    )
}
